import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-benefits-grid" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_benefit_item = _resolveComponent("benefit-item")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-benefits-grid__stamp" }, null, -1 /* CACHED */)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.marketingServicesBenefits, (benefit) => {
      return (_openBlock(), _createBlock(_component_benefit_item, _mergeProps({
        key: benefit.creatorBenefitID
      }, { ref_for: true }, benefit), null, 16 /* FULL_PROPS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}